const dev = {
    s3: {
        BUCKET: "YOUR_DEV_S3_UPLOADS_BUCKET_NAME"
    },
    apiGateway: {
        VERSION: "v2/",
        URL: "http://3.209.209.114/api/"
        // URL:"http://tspldemo.triazinesoft.com:3000/api/"
    }
};

const prod = {
    s3: {
        BUCKET: "YOUR_DEV_S3_UPLOADS_BUCKET_NAME"
    },
    apiGateway: {
        VERSION: "v2/",
        URL: "http://3.209.209.114/api/"
        // URL:"http://tspldemo.triazinesoft.com:3000/api/"
        // URL: "/api/"
    }
};

const config = process.env.NODE_ENV === 'production'
    ? prod
    : dev;

export default {
    // Add common config values here
    MAX_ATTACHMENT_SIZE: 5000000,
    ...config
};